<fwc-modal id="addressModal" text-header="Address Review">
  <div slot="body">
    <h4>Suggested address found for entered address.</h4>
    <p class="top-xs">Please review your entered address and select an option.</p>

    <div class="fwc-container sae-waiver-cards">
      <div class="fwc-row a-stretch">
        <div class="fwc-col-6 sm-12 fwc-card-generic flat card-container cursor_pointer"
          [ngClass]="{'selected' :selectedAddress == 'current'}" 
          (click)="selectedAddress = 'current'; refreshFocusTrap()"
          (keydown.enter)="selectedAddress = 'current'; refreshFocusTrap()"
          (keydown.space)="selectedAddress = 'current'; refreshFocusTrap(); $event.preventDefault()"
          tabindex="0"
          role="button"
          [attr.aria-pressed]="selectedAddress == 'current'">
          <h5 class="btm-xxs">
            Entered address <span class="fwc-icon fwc-icon-circle-check left-xxs"></span>
          </h5>
          <h6>{{aboutYouFormData?.address}}</h6>
          @if (aboutYouFormData?.address2) {
            <h6>{{aboutYouFormData?.address2}}</h6>
          }
          <h6> {{aboutYouFormData?.city}}, {{aboutYouFormData?.state}} {{aboutYouFormData?.zip}}</h6>
        </div>

        <div class="fwc-col-6 sm-12 fwc-card-generic flat card-container cursor_pointer"
          [ngClass]="{'selected' : selectedAddress == 'suggested' }" 
          (click)="selectedAddress = 'suggested'; refreshFocusTrap()"
          (keydown.enter)="selectedAddress = 'suggested'; refreshFocusTrap()"
          (keydown.space)="selectedAddress = 'suggested'; refreshFocusTrap(); $event.preventDefault()"
          tabindex="0"
          role="button"
          [attr.aria-pressed]="selectedAddress == 'suggested'">
          <h5 class="btm-xxs">
            Suggested address <span class="fwc-icon fwc-icon-circle-check left-xxs"></span>
          </h5>
          <h6>{{suggestedAddress?.address}}</h6>
          @if (suggestedAddress?.address2) {
            <h6>{{suggestedAddress?.address2}}</h6>
          }
          <h6> {{suggestedAddress?.city}}, {{suggestedAddress?.state}} {{suggestedAddress?.zipcode}}</h6>
        </div>
      </div>
    </div>
  </div>

  <div slot="actions">
    <button class="fwc-btn fwc-btn-secondary" id="btnClose" (click)="onBack()">Back</button>
    <button class="fwc-btn fwc-btn-primary" id="btnApply" (click)="onConfirmClick()" [disabled]="!selectedAddress">Save and Continue</button>
  </div>
</fwc-modal>